import { useTranslatedOptionEnum } from '@if/mui'
import type { SxProps } from '@mui/material'
import { FormControl, InputLabel, Select } from '@mui/material'
import type { Theme } from '@mui/material/styles'
import { ELoanStatus, getELoanStatusList } from '@src/types/constants'
import { useId } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  sx?: SxProps<Theme>
  currentStatus: ELoanStatus
}

const LoanCalendarStatusSelect = ({ sx, currentStatus }: Props) => {
  const { t } = useTranslation()
  const labelId = useId()
  const options = useTranslatedOptionEnum('loan.statuses', getELoanStatusList())

  return (
    <FormControl sx={{ minWidth: 190, ...sx }}>
      <InputLabel id={labelId}>{t('common.status')}</InputLabel>
      <Select labelId={labelId} label={t('common.status')} defaultValue={currentStatus}>
        {options}
      </Select>
    </FormControl>
  )
}

export default LoanCalendarStatusSelect
